
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import firebase from 'firebase';

/*
  ApiV1 to the backend server: https://us-central1-gvtcloudconnection.cloudfunctions.net/apiV1

*/
@Injectable()
export class ApiV1 {

  private serverUrl = 'https://us-central1-gvtcloudconnection.cloudfunctions.net/apiV1';


  constructor(public http: Http) {
    console.log('Hello ApiV1 Provider');
  }




  private getAuthHeader() : firebase.Promise<Headers> {

    return firebase.auth().currentUser.getIdToken().then( (token) => { 
      let headers = new Headers( { 
        'Authorization': 'Bearer ' + token, 
        'Content-Type': 'application/json' 
      });
      return headers;
    });

  }

 private getHeader() : firebase.Promise<Headers> {

    let headers = new Headers( { 
      'Content-Type': 'application/json' 
    });
    
    return Promise.resolve(headers);
  }


  private handleError(response: any): Promise<any> {

    let j = response.json();
    // console.error('An error occurred', j.error); // for demo purposes only
    return Promise.reject(j.error);
    // return Promise.reject(j.error.message || j.error);

  }

 


  //
  // Call hello
  hello() : firebase.Promise<any>{
  
    return this.getAuthHeader().then( (headers) => { 

      const url = `${this.serverUrl}/hello`;
      return this.http.get( url, {headers: headers} ).toPromise();

    }).then( (response) => { 
      
      return ""; 

    }).catch(this.handleError);  
  }


  // 
  // Create a Firebase user
  createUser(user) : firebase.Promise<any>{

    return this.getAuthHeader().then( (headers) => { 
        
        const url = `${this.serverUrl}/createUser`;
        return this.http.post( url, JSON.stringify(user), {headers: headers} ).toPromise();

      }).then( (response) => { 
        
        let j = response.json();
        return j; 

      }).catch(this.handleError);  
  }


  //
  // Update a Firebase user
  updateUser(uid, user) : firebase.Promise<any>{

    return this.getAuthHeader().then( (headers) => { 
        
        let body = {
          uid: uid,
          user: user
        };
      
        const url = `${this.serverUrl}/updateUser`;
        return this.http.post( url, JSON.stringify(body), {headers: headers} ).toPromise();

      }).then( (response) => { 
        
        let j = response.json();
        return j; 

      }).catch(this.handleError);  
  }

  // 
  // Delete a Firebase user
  deleteUser(uid) : firebase.Promise<any>{

    return this.getAuthHeader().then( (headers) => { 
        
        let body = {
          uid: uid
        };
        const url = `${this.serverUrl}/deleteUser`;
        return this.http.post( url, JSON.stringify(body), {headers: headers} ).toPromise();

      }).then( (response) => { 
        
        let j = response.json();
        return j; 

      }).catch(this.handleError);  
  }


  //
  // Get the new custom token for the current user
  signInCustomToken(email:string, password:string) : firebase.Promise<any>{
 
   return this.getHeader().then( (headers) => { 

      let body = {
        email:  email,
        password: password
      };
      
      const url = `${this.serverUrl}/signIn`;

      return this.http.post( url, JSON.stringify(body), {headers: headers} ).toPromise();

    }).then( (response) => { 
      
      let j = response.json();
      return j; 

    }).catch(this.handleError);  
    
  }

  signInCustomTokenOld() : firebase.Promise<any>{

    return this.getAuthHeader().then( (headers) => { 

      let body = {
        "uid": firebase.auth().currentUser.uid
      };
      
      const url = `${this.serverUrl}/signIn`;

      return this.http.post( url, JSON.stringify(body), {headers: headers} ).toPromise();

    }).then( (response) => { 
      
      let j = response.json();
      return j; 

    }).catch(this.handleError);  
  }

  




  //
  // Write log 
  writeLog( device: string, cloud: string, what: string) {

    return this.getAuthHeader().then( (headers) => { 
  
      let body = {
        "device": device,
        "cloud": cloud,
        "what": what
      };
      
      const url = `${this.serverUrl}/writeLog`;
      return this.http.post( url, JSON.stringify(body), {headers: headers} ).toPromise();
    
    }).then( (response) => { 

      return true;

    }).catch(this.handleError);

  }
 
 






  //
  // Get LicIds Tag Value, return an array of {licId, tag, value}
  getLicIdTagValues(licId, tag) : firebase.Promise<any>{

    // if (req.query.licId)  query.filter('licId', req.query.licId);
    // if (req.query.tag)  query.filter('tag', req.query.tag);

    return this.getAuthHeader().then( (headers) => { 
      
      const url = `${this.serverUrl}/licIdTagValues`;

      return this.http.get( url, {headers: headers} ).toPromise();

    }).then( (response) => { 
      
      let j = response.json();
      return j; 

    }).catch(this.handleError);  
  }


  // Set an array of {LicId Tag Value}
  setLicIdTagValue(tab : [{licId:string, tag:string, value:string}] ) : firebase.Promise<any>{

    return this.getAuthHeader().then( (headers) => { 

      let body = {
        array : tab
      };
      
      const url = `${this.serverUrl}/licIdTagValues`;

      return this.http.post( url, JSON.stringify(body), {headers: headers} ).toPromise();

    }).then( (response) => { 
      
      let j = response.json();
      return j; 

    }).catch(this.handleError);  
  }




}



// WEBPACK FOOTER //
// ./src/providers/api-v1.ts